var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBusinessTypeOther(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "58px",
    height: "58px",
    viewBox: "0 0 58 58",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Onboarding",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "03-Company-type",
    transform: "translate(-916.000000, -261.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-business-type-other",
    transform: "translate(916.000000, 261.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29,0 C13.009,0 0,13.01 0,29 C0,44.99 13.009,58 29,58 C44.991,58 58,44.99 58,29 C58,13.01 44.991,0 29,0 Z M29,56 C14.112,56 2,43.888 2,29 C2,14.112 14.112,2 29,2 C43.888,2 56,14.112 56,29 C56,43.888 43.888,56 29,56 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29,48 C28.448,48 28,48.447 28,49 L28,51 C28,51.553 28.448,52 29,52 C29.552,52 30,51.553 30,51 L30,49 C30,48.447 29.552,48 29,48 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.013,48.077 C34.87,47.543 34.322,47.224 33.788,47.37 C33.254,47.513 32.938,48.061 33.081,48.595 L33.599,50.527 C33.719,50.974 34.122,51.268 34.564,51.268 C34.649,51.268 34.737,51.257 34.823,51.234 C35.357,51.091 35.673,50.543 35.53,50.009 L35.013,48.077 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.75,45.521 C19.272,45.245 18.66,45.408 18.384,45.887 L17.384,47.618 C17.108,48.097 17.271,48.708 17.75,48.984 C17.907,49.075 18.08,49.118 18.249,49.118 C18.595,49.118 18.931,48.939 19.116,48.618 L20.116,46.887 C20.392,46.409 20.229,45.798 19.75,45.521 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.616,45.888 C39.34,45.409 38.728,45.245 38.25,45.522 C37.771,45.798 37.608,46.41 37.884,46.888 L38.884,48.619 C39.069,48.94 39.405,49.119 39.751,49.119 C39.92,49.119 40.093,49.076 40.25,48.985 C40.729,48.709 40.892,48.097 40.616,47.619 L39.616,45.888 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.212,47.37 C23.677,47.226 23.13,47.544 22.987,48.077 L22.469,50.009 C22.326,50.542 22.642,51.091 23.176,51.234 C23.263,51.257 23.35,51.268 23.435,51.268 C23.876,51.268 24.281,50.974 24.4,50.527 L24.918,48.595 C25.062,48.062 24.746,47.513 24.212,47.37 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41,28 L30,28 L30,17 C30,16.447 29.552,16 29,16 C28.448,16 28,16.447 28,17 L28,28 L17,28 C16.448,28 16,28.447 16,29 C16,29.553 16.448,30 17,30 L28,30 L28,41 C28,41.553 28.448,42 29,42 C29.552,42 30,41.553 30,41 L30,30 L41,30 C41.552,30 42,29.553 42,29 C42,28.447 41.552,28 41,28 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.351,9.322 C37.06,9.587 37.766,9.896 38.45,10.241 C38.595,10.314 38.748,10.348 38.9,10.348 C39.266,10.348 39.618,10.147 39.794,9.798 C40.043,9.306 39.845,8.704 39.352,8.455 C38.602,8.077 37.829,7.738 37.051,7.448 C36.533,7.255 35.957,7.517 35.764,8.035 C35.571,8.553 35.833,9.13 36.351,9.322 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.151,14.15 C18.9,9.403 25.701,7.201 32.338,8.265 C32.881,8.355 33.396,7.982 33.484,7.436 C33.571,6.891 33.2,6.377 32.655,6.29 C25.383,5.123 17.939,7.534 12.738,12.735 C3.77,21.703 3.77,36.295 12.738,45.262 C12.933,45.457 13.189,45.555 13.445,45.555 C13.701,45.555 13.957,45.457 14.152,45.262 C14.543,44.871 14.543,44.239 14.152,43.848 C5.963,35.661 5.963,22.339 14.151,14.15 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.263,12.736 C44.603,12.076 43.898,11.451 43.17,10.881 C42.736,10.541 42.107,10.617 41.766,11.052 C41.425,11.487 41.502,12.114 41.936,12.455 C42.602,12.976 43.245,13.547 43.849,14.15 C52.037,22.338 52.037,35.661 43.849,43.849 C43.458,44.24 43.458,44.872 43.849,45.263 C44.044,45.458 44.3,45.556 44.556,45.556 C44.812,45.556 45.068,45.458 45.263,45.263 C54.231,36.296 54.231,21.704 45.263,12.736 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBusinessTypeOther);
export default __webpack_public_path__ + "static/media/icon-business-type-other.4c383c07bad13313babbf4a3acd1845b.svg";
export { ForwardRef as ReactComponent };